<div class="label">
  <ng-content select="label"></ng-content>
</div>
  

<ng-content></ng-content>
